import React, {useEffect} from 'react';
import {ColumnDescription} from "react-bootstrap-table-next";
import {useDispatch, useSelector} from "react-redux";
import paginationFactory from "react-bootstrap-table2-paginator";
import Client from "../../../../Models/Client";
import Address from "../../../../Models/Address";
import {RootState} from "../../../../Store/Reducers";
import ColumnAction from "../../ColumnAction";
import LoadingComponent from "../../LoadingComponent";
import Bootstrap4Table from "../../Bootstrap4Table/Bootstrap4Table";
import {AddressActions} from "../../../../Store/Address/Slice";

interface IProps {
  selectable?: boolean;
  client: Client;
  onOpenAddressModal?: (e: any, row: Address) => void;
  onOpenConfirmModal?: (row: Address) => void;
  onClose?: (row: Address) => void;
  setAddressSelected?: (row: Address) => void;
  perPage?: number;
}

const AddressTableComponent: React.FC<IProps> = ({
  selectable,
  client,
  onOpenAddressModal,
  onOpenConfirmModal,
  setAddressSelected,
  onClose,
  perPage = 15,
}) => {

  const addresses = useSelector((state: RootState) => state.AddressReducer.addresses);
  const { loadingAddresses } = useSelector((state: RootState) => state.LoadingReducer);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(AddressActions.getAddresses({ customer: client._KEY }));
  }, [dispatch, client._KEY]);

  const actionFormat = (cell: any, row: Address) => {
    return(
      <ColumnAction
        onEdit={(e: any) => onOpenAddressModal && onOpenAddressModal(e, row)}
        onRemove={(e: any) => onOpenConfirmModal && onOpenConfirmModal(row)}
      />
    )
  }

  const notAllowFormat = (cell: any, row: Address) => {
    return (
      <input type="checkbox" checked={row.notallow} disabled={true}/>
    )
  }

  const columns: ColumnDescription[] = [{
    dataField: "address",
    text: "DIRECCIÓN"
  }, {
    dataField: "city.name",
    text: "CIUDAD"
  }, {
    dataField: "neighborhood",
    text: "BARRIO"
  }];

  let props: any = {}

  if (selectable) {
    props.selectRow = {
      mode: "radio",
      clickToSelect: true,
      onSelect: (address: Address) => {
        setAddressSelected && setAddressSelected(address);
      }
    }
    props.rowEvents = {
      onClick: (e: any, row: Address) => {
        setAddressSelected && setAddressSelected(row);
      },
      onDoubleClick: (e: any, row: Address) => {
        onClose && onClose(row);
      }
    }
  } else {
    columns.push( {
      dataField: "notallow",
      text: "NO PERMITIDA",
      formatter: notAllowFormat
    }, {
      dataField: "",
      text: "ACCIONES",
      formatter: actionFormat
    })
  }

  return (
    <>
      <LoadingComponent loading={loadingAddresses.status}/>
      <Bootstrap4Table
        data={addresses}
        columns={columns}
        {...props}
        pagination={paginationFactory({sizePerPage: perPage, hideSizePerPage: true})}
        loading={loadingAddresses.status.isLoading()}
      />
    </>
  );
};
export default AddressTableComponent;
